import { useQueryTab } from "../Hooks/useQueryTab";
import ButtonGroup from "../components/ui/Button/ButtonGroup.jsx";
import ToggleButton from "../components/ui/Button/ToggleButton.jsx";
import NavBar from "../components/NavBar/NavBar.jsx";
import Footer from "../components/Footer/Footer.jsx";
import EventPage from "../components/Profile/EventsAndSpaces/Events/EventsListPage.jsx";
import SpacesPage from "../components/Profile/EventsAndSpaces/Spaces/SpacesListPage.jsx";
import OrdersListPage from "../components/Profile/EventsAndSpaces/Orders/OrdersListPage.jsx";
import { useTranslation } from "react-i18next";

export default function SpacesAndEvents() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useQueryTab("tab", "events");

  const renderContent = () => {
    switch (activeTab) {
      case "spaces":
        return <SpacesPage />;
      case "orders":
        return <OrdersListPage />;
      case "events":
        return <EventPage />;
      default:
        return null;
    }
  };

  return (
    <>
      <NavBar />
      <div className=" mx-auto pt-14 px-4 pb-4 bg-grey-500 ">
        <div className="flex justify-center items-center mb-10">
          <ButtonGroup spacing="md">
            {/* Events Button */}
            <ToggleButton
              active={activeTab === "events"}
              onClick={() => setActiveTab("events")}
              size="sm"
            >
              {t("navigation.events")}
            </ToggleButton>

            {/* Orders Button */}
            <ToggleButton
              active={activeTab === "orders"}
              onClick={() => setActiveTab("orders")}
              size="sm"
            >
              Orders
            </ToggleButton>
          </ButtonGroup>
        </div>
        {renderContent()}
      </div >
    </>
  );
}
